import { gql } from "@stadium/services/apollo-client";

export const fetchExternalStore = gql`
  query RestStoreDetail($storeId: String!, $programIntent: String) {
    externalStore(store_id: $storeId, program_intent: $programIntent)
      @rest(type: "ExternalStore", path: "/users/store_data?{args}") {
      availableStoreSpecificPoints
      order {
        id
        number
        itemCount
      }
    }
  }
`;
